import React, { memo, useEffect } from 'react'

import PolyCountContent, { QUICK_SELECTIONS } from 'Pods/SearchPage/Shared/PolyCountContent/PolyCountContent'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { clearPolygon } from 'Pods/SearchPage/Store/actions/polygon'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'

function PolyCount() {
  const t = useTranslate()

  const polygonRanges = useSearchPageStore(state => state.polygonRanges)
  const minPolygon = useSearchPageStore(state => state.minPolygon)
  const maxPolygon = useSearchPageStore(state => state.maxPolygon)

  // PolyCount only mounts when assetType === THREE_D_ONLY (see SecondaryFilters),
  // so unmount means the user switched to a different asset type - drop the
  // polygon selection so it does not silently carry over.
  useEffect(() => () => clearPolygon(), [])

  const isCustomRangeActive = minPolygon !== undefined || maxPolygon !== undefined
  const selectionCount = polygonRanges.length + (isCustomRangeActive ? 1 : 0)
  const hasSelectedAnyFilters = selectionCount > 0

  return (
    <FiltersWrapper
      trailIconSize="small"
      placeholder={t('search_page.filters.poly_count.title')}
      selectedCount={selectionCount}
      // Presets and the custom range are mutually exclusive, so the preset count is the widest label.
      reservedCount={QUICK_SELECTIONS.length}
      content={<PolyCountContent />}
      hasSelectedAnyFilters={hasSelectedAnyFilters}
      positionHorizontal="left"
      closingDropdownClassName="filter-wrapper"
    />
  )
}

export default memo(PolyCount)
